import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-white text-[#2C3333] border border-[#E5E5E0] shadow-lg rounded-lg",
          description: "text-[#5C5C5C]",
          actionButton:
            "bg-[#8DA399] text-white",
          cancelButton:
            "bg-[#E5E5E0] text-[#5C5C5C]",
          success: "bg-[#8DA399] text-white border-[#8DA399]",
          error: "bg-red-50 text-red-600 border-red-200",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
